import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import { getMonthDayYear } from 'helpers/DateUtil'
import Schedule from 'components/fulcrum/schedule/Schedule'
import { displayError } from 'helpers/validator'

import styles from './styles.scss'

class NotebookSchedule extends React.Component {
  constructor(props){
    super(props)

    this.plannedSchedule = [
      'Design Review',
      'Qualification',
      'Mass Production',
    ]

    this.buildSchedule = [
      'EVT/SMT Build',
      'DVT/SMT Build',
      'PVT/SMT Build',
      'Pilot Build',
    ]

    this.swSchedule = [
      'SBIOS/VBIOS Lock',
      'WHQL RC',
      'WHQL Production',
    ]
  }

  componentDidMount() {
    this.props.initUi(this.props.values)
  }

  onInputChange = (label) => (text) => {
    this.props.onInputChange(label, text)
    this.props.onInputUiChange(label, text)
  }

  onDateChange = (label) => (date) => {
    this.props.onDateChange(label, date)
    this.props.onInputUiChange(label, getMonthDayYear(date).replace(/\//g, ''))
  }

  getError = (label) => {
    const {
      inputText,
      rules,
      showError
    } = this.props
    let error = ''
    if (showError && inputText[label])
      error = displayError(inputText[label], rules)
    return error
  }

  render() {
    const {
      formatDates,
      inputText,
    } = this.props

    return (
      <div>
        <h5 styleName='scheduleTitle'>Planned Project Schedule</h5>
        {
          this.plannedSchedule.map(label => (
            <Schedule
              error={this.getError(label)}
              minDate={new Date()}
              key={label}
              label={label}
              input={inputText[label]}
              onInputChange={this.onInputChange(label)}
              onDateChange={this.onDateChange(label)}
              dateInput={formatDates[label]}
            />
          ))
        }
        <h5 styleName='scheduleTitle'>Planned Build Schedule</h5>
        {
          this.buildSchedule.map(label => (
            <Schedule
              error={this.getError(label)}
              minDate={new Date()}
              key={label}
              label={label}
              input={inputText[label]}
              onInputChange={this.onInputChange(label)}
              onDateChange={this.onDateChange(label)}
              dateInput={formatDates[label]}
            />
          ))
        }
        <h5 styleName='scheduleTitle'>Planned Software Schedule</h5>
        {
          this.swSchedule.map(label => (
            <Schedule
              error={this.getError(label)}
              minDate={new Date()}
              key={label}
              label={label}
              input={inputText[label]}
              onInputChange={this.onInputChange(label)}
              onDateChange={this.onDateChange(label)}
              dateInput={formatDates[label]}
            />
          ))
        }
      </div>
    )

  }
}

export default CSSModules(styles, NotebookSchedule)
